export const SCROLL_BAR_CONFIGURATION = {};
